import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-3.637 4.352A5.476 5.476 0 0 1 8 13.5a5.476 5.476 0 0 1-3.363-1.147L5.71 11.28A3.98 3.98 0 0 0 8 12c.852 0 1.642-.266 2.29-.72l1.073 1.072Zm.99-.99A5.476 5.476 0 0 0 13.5 8a5.477 5.477 0 0 0-1.147-3.362L11.28 5.71A3.98 3.98 0 0 1 12 8c0 .851-.266 1.64-.72 2.29l1.073 1.072Zm-.99-7.714L10.29 4.72A3.982 3.982 0 0 0 8 4a3.98 3.98 0 0 0-2.29.72L4.638 3.647A5.476 5.476 0 0 1 8 2.5c1.267 0 2.433.428 3.363 1.148Zm-7.715.99A5.476 5.476 0 0 0 2.5 8a5.48 5.48 0 0 0 1.147 3.363L4.72 10.29A3.982 3.982 0 0 1 4 8c0-.852.266-1.642.72-2.29L3.648 4.637ZM8 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function r(a, d) {
  return e(), o("svg", c, [...n]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
